// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterPage_root__njzWz"};